<template>
    <div class="certificate">
        <Header class="gallery-header" />
        <div class="clearfix"></div>
        <div class="certifi-main">
            <div class="banner">
                <img src="../../assets/images/front-desk/ssl-banner.png" alt="SSL证书" />
            </div>

            <!-- 简介 -->
            <section class="content">
                <div class="profile">
                    <h3>SSL证书简介</h3>
                    <p>SSL证书（SSL Certificates）又叫服务器证书，通过在客户端浏览器和Web服务器之间建立一条SSL安全通道（Secure socket layer SSL)，对传送的数据进行加密和隐藏；确保数据在传送中不被改变，即数据的完整性即通过它可以激活SSL协议，实现数据信息在客户端和服务器之间的加密传输，可以防止数据信息的泄露，保证了双方传递信息的安全性，而且用户可以通过服务器证书验证他所访问的网站是否是真实可靠。</p>
                    <!-- <a href="" class="buy">立即选购</a> -->
                </div>
            </section>
            <!-- 产品	 -->
            <div class="product">
                <div class="content">
                    <h2 class="section-title">https加密协议 让网站安全防劫持</h2>
                    <div class="product-con">
                        <div class="product-item">
                            <div class="product-top"></div>
                            <div class="product-title">
                                站神升级支持SSL证书服务包
                                <br />（含证书）
                            </div>
                            <div class="product-desc">
                                <p>1.站神空间高配升级，支持CDN加速+150G/年流量</p>
                                <p>2.技术安装服务配置服务</p>
                                <p>3.包含GeoTrust域名型（DV）SSL</p>
                            </div>
                            <div class="product-txt">
                                <p>
                                    <img src="../../assets/images/front-desk/geo.png" alt />
                                </p>GeoTrust是全球第二大数字证书颁发机构，已被Symantec收购。该品牌证书由工信部许可设立的电子认证服务机构“天威诚信”提供鉴证服务
                            </div>
                            <div class="product-money">
                                <span>1878</span>
                                <em>元/年</em> 省1200元
                            </div>
                            <div class="product-btn" @click="qyJump('/floor/Manager?goods_id=479&cat_id=147',1878)">立即购买</div>
                        </div>
                        <div class="product-item">
                            <div class="product-title">
                                站神升级支持SSL证书服务包
                                <br />（不含证书）
                            </div>
                            <div class="product-desc">
                                <p>1.站神空间高配升级，支持CDN加速+150G/年流量</p>
                                <p>2.技术安装服务配置服务</p>
                            </div>
                            <div class="product-txt">
                                <p>
                                    <img src="../../assets/images/front-desk/cdn.png" alt />
                                </p>依靠部署在各地的服务器，通过中心平台的负载均衡、内容分发、调度等功能模块，使用户就近获取所需内容，降低网络拥塞，提高用户访问响应速度和命中率
                            </div>
                            <div class="product-money">
                                <span>800</span>
                                <em>元/年</em> 省200元
                            </div>
                            <div class="product-btn" @click="qyJump('/floor/serve?goods_id=666',800)">立即购买</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 优势 -->
            <section class="merit">
                <h2 class="section-title">站神SSL证书四大优势</h2>
                <div class="content">
                    <ul class="clearfix list">
                        <li class="item">
                            <img src="../../assets/images/front-desk/merit-ca.png" alt="顶级CA机构" />
                            <h4>顶级CA机构</h4>
                            <p>
                                SSL证书由国际顶级CA机构
                                <br />授权颁发，安全有保障
                            </p>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/front-desk/merit-jiami.png" alt="数据加密传输" />
                            <h4>数据加密传输</h4>
                            <p>
                                实现网站HTTPS化,加密用户与网站
                                <br />间的交互访问,强化网站用户侧可信
                                <br />展示程度,防劫持、防篡改、防监听。
                            </p>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/front-desk/merit-paiming.png" alt="提升搜索排名" />
                            <h4>提升搜索排名</h4>
                            <p>
                                采用HTTPS有利于提升网站
                                <br />在搜索引擎排名及站点可信度。
                            </p>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/front-desk/merit-ssl.png" alt="快速签发SSL证书" />
                            <h4>快速签发SSL证书</h4>
                            <p>
                                站神专员帮助客户快速审核SSL
                                <br />证书签发
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <!-- 快速选购表 -->
            <section class="quick-buy">
                <h2 class="section-title">SSL证书快速选购表</h2>
                <div class="content">
                    <div class="table">
                        <table>
                            <colgroup>
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <td>域名类型</td>
                                    <td>支持内容</td>
                                    <td>场景</td>
                                    <td>域名示例</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>单域名</td>
                                    <td>仅支持绑定一个普通域名</td>
                                    <td>仅一个域名</td>
                                    <td>示例：www.nswyun.com</td>
                                </tr>
                                <tr>
                                    <td>多域名</td>
                                    <td>可以绑定多个普通域名</td>
                                    <td>多个域名便捷管理</td>
                                    <td>
                                        <p>示例：通配符域名</p>
                                        <p>test1.nswyun.com</p>
                                        <p>tset2.nswyun.com</p>
                                        <p>test3.nswyun.com</p>
                                        <p>均在*.nswyun.com包含范围内</p>
                                        <p>(不支持非同级域名，如：x1.test1.nswyun.com)</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>通配符域名</td>
                                    <td>仅支持绑定一个泛域名</td>
                                    <td>多个同级子域名，便于拓展</td>
                                    <td>
                                        <p>示例：通配符域名</p>
                                        <p>test1.nswyun.com</p>
                                        <p>tset2.nswyun.com</p>
                                        <p>test3.nswyun.com</p>
                                        <p>均在*.nswyun.com包含范围内</p>
                                        <p>(不支持非同级域名，如：x1.test1.nswyun.com)</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            <!-- 应用场景 -->
            <section class="scene">
                <h2 class="section-title">应用场景</h2>
                <div class="content">
                    <div class="scene-tabbar">
                        <ul class="clearfix tabs">
                            <li class="tab-item active" :class="sceneIndex===1 ? 'active' :''" @click="sceneSwitch(1)">
                                <span>网站可信认证</span>
                            </li>
                            <li class="tab-item" :class="sceneIndex===2 ? 'active' :''" @click="sceneSwitch(2)">
                                <span>应用可信认证</span>
                            </li>
                            <li class="tab-item" :class="sceneIndex===3 ? 'active' :''" @click="sceneSwitch(3)">
                                <span>应用数据传输保护</span>
                            </li>
                        </ul>
                        <div class="contents">
                            <div class="content-item" :class="sceneIndex===1 ? 'show' :''">
                                <h4>适用于网站建设</h4>
                                <ul class="clearfix list">
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/scene-ca.png" alt="权威CA机构" />
                                        <h5>权威CA机构</h5>
                                        <p>
                                            SSL证书由国际权威CA机构授权颁发，
                                            <br />证书权威可靠
                                        </p>
                                    </li>
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/scene-shenfen.png" alt="可信身份" />
                                        <h5>可信身份</h5>
                                        <p>
                                            为用户建立的网站提供基于数字证书的
                                            <br />可信身份认证支持，避免网站被仿冒
                                        </p>
                                    </li>
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/scene-leibie.png" alt="证书类别丰富" />
                                        <h5>证书类别丰富</h5>
                                        <p>
                                            提供组织型（OV）和增强型（EV）等多种
                                            <br />证书，便于企业根据自身业务场景灵活选择
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="content-item" :class="sceneIndex===2 ? 'show' :''">
                                <h4>适用于云应用服务、移动应用服务</h4>
                                <ul class="clearfix list">
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/scene-ca.png" alt="权威CA机构" />
                                        <h5>权威CA机构</h5>
                                        <p>
                                            SSL证书由国际权威CA机构授权颁发，
                                            <br />证书权威可靠
                                        </p>
                                    </li>
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/scene-guanli.png" alt="全局证书管理" />
                                        <h5>全局证书管理</h5>
                                        <p>
                                            全局管理证书，方便用户查看所有应用的
                                            <br />证书并进行管理
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="content-item" :class="sceneIndex===3 ? 'show' :''">
                                <h4>适用于网站、应用与客户端之间的数据传输</h4>
                                <ul class="clearfix list">
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/scene-ca.png" alt="传输加密" />
                                        <h5>传输加密</h5>
                                        <p>
                                            对客户端与网站、应用之间的传输数据加密，
                                            <br />防止数据中途被窃取，维护数据完整性，防篡改
                                        </p>
                                    </li>
                                    <li class="item">
                                        <img src="../../assets/images/front-desk/function-shenqing.png" alt="简单方便" />
                                        <h5>简单方便</h5>
                                        <p>
                                            提供一站式云上证书申请、管理、查询、验证等
                                            <br />能力，将证书应用到站神服务的各个环节中
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- 功能描述 -->
            <section class="function">
                <h2 class="section-title">功能描述</h2>
                <div class="content">
                    <ul class="clearfix list">
                        <li class="item">
                            <img src="../../assets/images/front-desk/function-shenqing.png" alt="证书申请与管理" />
                            <h4>证书申请与管理</h4>
                            <p>
                                提供云上一站式证书申请、管理的能力，
                                <br />降低证书的管理难度，提升用户体验。
                            </p>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/front-desk/function-bushu.png" alt="一键部署" />
                            <h4>一键部署</h4>
                            <p>
                                为提升证书使用便捷性，通过SCM将证书
                                <br />直接推送给站神平台，如CDN/ELB/WAF。
                            </p>
                        </li>
                        <li class="item">
                            <img src="../../assets/images/front-desk/function-xiazai.png" alt="多种类型下载" />
                            <h4>多种类型下载</h4>
                            <p>
                                可将证书转换为tomcat、Nginx、Apache
                                <br />和IIS四种格式，覆盖业界99%的网站服务器类型。
                            </p>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
        <RightHelp />
        <Footer></Footer>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from '@/pages/Layout/Header'
import RightHelp from '@/pages/Layout/RightHelp'
import Footer from '@/pages/Layout/Footer'
export default {
    name: 'certificate',
    components: {
        Header, RightHelp, Footer
    },
    data () {
        return {
            sceneIndex: 1
        }
    },
    created () {
    },
    methods: {

        ...mapActions('member', ['authorizeNewNSY']),
        sceneSwitch (index) {
            this.sceneIndex = index
        },
        async qyJump (route, price) {


            const parmas = {
                route,
                type: '0',
            }
            const data = await this.authorizeNewNSY(parmas)
            if (data.isSuccess) {
                let url = ''
                if (!data.nswUrl) {
                    url = price === 800 ? 'https://www.nswyun.com/floor/serve?goods_id=666' : 'https://www.nswyun.com/floor/Manager?goods_id=479&cat_id=147'
                } else {
                    url = data.nswUrl
                }
                window.open(url)
            } else {
                this.$message.error('授权登陆失败')
            }
            // let { data } = await MemberApi.authorizeNswYun({ clientId: 'nswyun-client' })
            // if (data.isSuccess) {
            //     let url = ``
            //     if (!data.data) {
            //         url = price === 800 ? 'https://www.nswyun.com/sd.php?id=209' : 'https://www.nswyun.com/floor/Manager?goods_id=479&cat_id=147'
            //     } else {
            //         url = `${data.data.nswyunUrl}${link}`
            //     }
            //     window.open(url)
            // } else {
            //     this.$message.error('授权登陆失败')
            // }
        }
    }

}
</script>

<style lang="scss" scoped>
.certifi-main {
    background-color: #f2f2f9;
}
.content {
    width: 1200px;
    margin: 0 auto;
}
.banner img {
    display: block;
    width: 100%;
}
.profile {
    position: relative;
    top: -60px;
    margin: 0 auto;
    height: 300px;
    padding: 60px 96px 0 422px;
    border-radius: 12px;
    box-sizing: border-box;
    background: #fff url(../../assets/images/front-desk/ssl-prefile.png)
        no-repeat 60px 34px;
}
.profile h3 {
    margin-bottom: 12px;
    color: #373d45;
    font-size: 18px;
}
.profile p {
    margin-bottom: 20px;
    color: #8392a4;
    line-height: 22px;
}
.profile .buy {
    display: inline-block;
    width: 168px;
    height: 44px;
    background-color: #f1592a;
    border-radius: 26px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 44px;
    color: #fff;
}
.section-title {
    text-align: center;
    font-size: 32px;
    color: #373d45;
}
.merit {
    padding: 40px 0 60px;
    background-color: #fff;
}
.merit .section-title {
    margin-bottom: 60px;
}
.merit .item {
    float: left;
    width: 25%;
    box-sizing: border-box;
    text-align: center;
}
.merit .item h4 {
    margin: 20px 0 8px;
    color: #373d45;
    font-size: 16px;
}
.merit .item p {
    min-height: 66px;
    font-size: 12px;
    color: #8392a4;
    line-height: 22px;
}
.quick-buy {
    padding: 60px 0;
}
.quick-buy .section-title {
    margin-bottom: 30px;
}
.quick-buy .table {
    border: 1px solid #dadee3;
    border-radius: 12px;
    background-color: #fff;
}
.quick-buy .table table {
    width: 100%;
    border-collapse: collapse;
}
.quick-buy .table td {
    padding-left: 40px;
}
.quick-buy .table thead tr {
    height: 50px;
    background-color: #4358ab;
    color: #fff;
    font-size: 13px;
}
.quick-buy .table thead td:first-child {
    border-top-left-radius: 12px;
}
.quick-buy .table thead td:last-child {
    border-top-right-radius: 12px;
}
.quick-buy .table tbody tr:nth-child(even) {
    background-color: #f7f7f7;
}
.quick-buy .table tbody td {
    padding-top: 16px;
    padding-bottom: 16px;
    font-size: 12px;
}
.scene {
    padding: 40px 0 60px;
    background-color: #fff;
}
.scene .scene-tabbar {
    margin-top: 50px;
}
.scene .scene-tabbar .tabs {
    border-bottom: 1px solid #8392a4;
}
.scene .scene-tabbar .tab-item {
    float: left;
    width: 33.33333%;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
}
.scene .scene-tabbar .tab-item span {
    position: relative;
    display: inline-block;
    padding: 10px 0;
    font-size: 16px;
    color: #373d45;
}
.scene .scene-tabbar .tab-item.active span {
    color: #4358ab;
}
.scene .scene-tabbar .tab-item.active span::after {
    position: absolute;
    left: 14px;
    right: 14px;
    bottom: -1px;
    height: 3px;
    border-radius: 10px;
    background-color: #4358ab;
    content: "";
}
.scene .scene-tabbar .contents .content-item {
    display: none;
}
.scene .scene-tabbar .contents .content-item.show {
    display: block;
}
.scene h4 {
    margin: 30px 0 40px;
}
.scene .list {
    text-align: center;
}
.scene .list .item {
    float: left;
    width: 33.33333%;
    box-sizing: border-box;
}
.scene .list .item h5 {
    margin: 20px 0 8px;
    font-size: 16px;
}
.scene .list .item p {
    font-size: 12px;
    color: #8392a4;
    line-height: 22px;
}
.function {
    padding: 60px 0 70px;
}
.function h2 {
    margin-bottom: 60px;
}
.function .list {
    text-align: center;
}
.function .list .item {
    float: left;
    width: 33.33333%;
    box-sizing: border-box;
}
.function .list .item h4 {
    margin: 20px 0 8px;
    font-size: 16px;
    color: #373d45;
}
.function .list .item p {
    font-size: 12px;
    color: #8392a4;
    line-height: 22px;
}
.recommend {
    padding: 40px 0 60px;
    background-color: #fff;
}
.recommend .section-title {
    margin-bottom: 60px;
}
.recommend .list {
    text-align: center;
}
.recommend .list .item {
    float: left;
    width: 50%;
    box-sizing: border-box;
}
.recommend .list .item:first-child .card {
    background-image: url(../../assets/images/front-desk/recommend-ddos.png);
}
.recommend .list .item:last-child .card {
    background-image: url(../../assets/images/front-desk/recommend-web.png);
}
.recommend .list .card {
    display: inline-block;
    width: 460px;
    height: 180px;
    padding-left: 200px;
    padding-right: 30px;
    box-sizing: border-box;
    border-radius: 12px;
    border: 1px solid #e0e7ee;
    background: no-repeat top left;
    text-align: right;
}
.recommend .list .card h4 {
    margin-top: 40px;
    margin-bottom: 8px;
    font-size: 16px;
    color: #333;
}
.recommend .list .card p {
    margin-bottom: 30px;
    font-size: 12px;
    color: #8392a4;
}
.recommend .list .card .to-detail {
    font-size: 16px;
    color: #4358ab;
}

.clearfix::after {
    display: block;
    clear: both;
    content: "";
}
.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.product {
    padding-bottom: 94px;
    .section-title {
        margin-bottom: 30px;
    }
    .product-con {
        display: flex;
        justify-content: space-around;
    }
    .product-item {
        position: relative;
        width: 522px;
        height: 744px;
        background: #ffffff;
        border: 1px solid #eaedf3;
        box-shadow: 1px 15px 41px 8px rgba(64, 64, 64, 0.1);
        border-radius: 10px;
    }
    .product-title {
        height: 176px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(../../assets/images/front-desk/certificate-icon2.png)
            no-repeat center top;
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        line-height: 42px;
        color: #fff;
    }
    .product-desc {
        padding: 20px 50px 0 45px;
        height: 138px;
        font-size: 18px;
        color: #212121;
        line-height: 34px;
        p {
            position: relative;
            // &:after{
            // 	content:"";
            // 	width: 8px;
            // 	height: 8px;
            // 	background: #1B1B1B;
            // 	border-radius: 4px;
            // 	position: absolute;
            // 	top: 18px;
            // 	left:-14px;
            // }
        }
    }
    .product-txt {
        p {
            height: 30px;
            margin: 10px 0;
        }
        height: 178px;
        padding: 0 77px 0 50px;
        font-size: 16px;
        line-height: 28px;
        color: #5d5d5d;
    }
    .product-money {
        height: 48px;
        margin-bottom: 52px;
        font-size: 20px;
        color: #848484;
        text-align: center;
        span {
            font-size: 56px;
            font-family: arial;
            line-height: 48px;
            color: #ff0000;
        }
        em {
            font-size: 24px;
            color: #000;
        }
    }
    .product-btn {
        margin: 0 auto;
        width: 350px;
        height: 60px;
        background: linear-gradient(90deg, #f22b19 0%, #f56418 100%);
        border-radius: 30px;
        font-size: 22px;
        color: #fff;
        text-align: center;
        line-height: 60px;
        cursor: pointer;
    }
    .product-top {
        position: absolute;
        top: -9px;
        right: -10px;
        width: 122px;
        height: 111px;
        background: url(../../assets/images/front-desk/certificate-icon1.png)
            no-repeat center top;
    }
}
</style>
